/**
 * The app's copy, and the typing that makes its keys checkable.
 *
 * `en.json` is imported rather than fetched so the first paint already has the
 * real text. Additional locales are registered as loaders in `app.config.ts`
 * and fetched on demand.
 */
import type { Dictionary, TranslationKeyOf } from '@kirigami/shared/i18n';

import EN from './en.json';

export const EN_DICTIONARY = EN satisfies Dictionary;

/** Every dotted key in `en.json`. */
export type AppTranslationKey = TranslationKeyOf<typeof EN>;

/**
 * Teaches `@kirigami/shared/i18n` which keys exist here, so `t('...')` calls
 * and `| t` bindings in templates fail to compile on a typo instead of
 * rendering the key at runtime.
 */
declare module '@kirigami/shared/i18n' {
  interface TranslationKeyRegistry {
    key: AppTranslationKey;
  }
}
